var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Autosuggest',{attrs:{"value":_vm.value,"label":_vm.config.PROFILE_ADDRESS_STATE,"disabled":_vm.disabled,"options":_vm.filteredStates},on:{"input":_vm.onInput,"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }